// Public
export const EMPTY = "";
export const PUBLIC_BASE = "/";
export const LOGIN = PUBLIC_BASE + "login";

// Private
export const PRIVATE_BASE = PUBLIC_BASE + "adq";
export const HOME = PRIVATE_BASE + "/home";

export const USERS = PRIVATE_BASE + "/users";
export const USER_DETAIL = USERS + "/:id";
export const ROLES = PRIVATE_BASE + "/roles";
export const ROLE_DETAIL = ROLES + "/:id";
export const PERMISSIONS_DATAAPI = PRIVATE_BASE + "/permissions/dataapi";
export const PERMISSIONS_CONTROLCENTRE =
  PRIVATE_BASE + "/permissions/controlcentre";
export const PERMISSIONS_CONTROLCENTRE_SECTIONS =
  PERMISSIONS_CONTROLCENTRE + "/sections";
export const PERMISSIONS_CONTROLCENTRE_ACCESSLEVEL =
  PERMISSIONS_CONTROLCENTRE_SECTIONS + "/accessLevel";

// Wildcards
export const ANY_PAGE = "*";

export const resolveUserDetail = (id) => USER_DETAIL.replace(":id", id);
export const resolveRoleDetail = (id) => ROLE_DETAIL.replace(":id", id);
